import { useEffect, useState } from 'react';
import * as pdfjs from 'pdfjs-dist/legacy/build/pdf';
import '../assets/styles/VignetteFichier.css';

// Le worker part dans le bundle : sans lui, pdf.js rend dans le fil principal
// et bloque la page le temps de lire chaque fichier.
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/legacy/build/pdf.worker.min.js',
  import.meta.url
).toString();

/** Vignettes déjà rendues, par URL : rouvrir l'onglet ne relit pas les PDF. */
const cache = new Map();

/**
 * Première page d'un PDF -> data URL PNG, à la largeur demandée.
 * Le cookie de session suit (withCredentials) : le fichier est servi par l'API.
 */
async function rendrePdf(url, largeur) {
  if (cache.has(url)) return cache.get(url);
  const doc = await pdfjs.getDocument({ url, withCredentials: true }).promise;
  try {
    const page = await doc.getPage(1);
    const base = page.getViewport({ scale: 1 });
    // Deux fois la largeur affichée : net sur les écrans denses.
    const echelle = (largeur * 2) / base.width;
    const viewport = page.getViewport({ scale: echelle });
    const canvas = document.createElement('canvas');
    canvas.width = Math.ceil(viewport.width);
    canvas.height = Math.ceil(viewport.height);
    await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
    const data = canvas.toDataURL('image/png');
    cache.set(url, data);
    return data;
  } finally {
    doc.destroy();
  }
}

/**
 * L'aperçu d'un fichier reçu : la première page d'un PDF, l'image elle-même
 * pour une photo ou un scan, sinon le pictogramme fourni en `secours`
 * (Word, tableur…). Tant que le PDF se lit, le pictogramme tient la place.
 */
function VignetteFichier({ url, mime, alt = '', secours = null, largeur = 200 }) {
  const type = String(mime || '');
  const estPdf = type === 'application/pdf';
  const estImage = type.startsWith('image/');
  const [image, setImage] = useState(estImage ? url : cache.get(url) || null);
  const [echec, setEchec] = useState(false);

  useEffect(() => {
    if (!estPdf || !url || cache.has(url)) return undefined;
    let vivant = true;
    rendrePdf(url, largeur)
      .then((data) => vivant && setImage(data))
      .catch(() => vivant && setEchec(true));
    return () => {
      vivant = false;
    };
  }, [url, estPdf, largeur]);

  if (image && !echec) {
    return (
      <img
        className={`vignette-fichier${estPdf ? ' vignette-fichier-page' : ''}`}
        src={image}
        alt={alt}
        loading="lazy"
        onError={() => setEchec(true)}
      />
    );
  }
  return (
    <span className={`vignette-fichier-secours${estPdf && !echec ? ' vignette-fichier-attente' : ''}`}>
      {secours}
    </span>
  );
}

export default VignetteFichier;
